<div class="card-body d-flex flex-column gap-4">
  <div
    class="d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-sm-end gap-4"
  >
    <button 
      class="btn m-outline-btn mb-3 mb-sm-0" 
      *ngIf="!hidePdfButton"
      (click)="exportHandler('pdf')">
      <i class="app-icon icon icon-file-pdf icon-lg"></i>
      <span>{{ "contractDetail.paymentSchedule.exportPdf" | translate }}</span>
    </button>
    <button 
      class="btn m-outline-btn" 
      *ngIf="!hideXlsButton"
      (click)="exportHandler('xlsx')">
      <i class="app-icon icon icon-file-excel icon-lg"></i>
      <span>{{ "contractDetail.paymentSchedule.exportXls" | translate }}</span>
    </button>
  </div>

  <dynamic-table [props]="props" class="payment-schedule-table">
    <table>
      <thead>
        <tr>
          <th scope="col" id="Number" width="7%">
            <div>{{ "contractDetail.paymentSchedule.number" | translate }}</div>
          </th>
          <th scope="col" id="Type">
            {{ "contractDetail.paymentSchedule.type" | translate }}
          </th>
          <th scope="col" id="Value">
            {{ "contractDetail.paymentSchedule.value" | translate }}
          </th>
          <th scope="col" id="Vat" *ngIf="contract.dictionaryContractType.code !== ContractType.CREDIT">
            {{ "contractDetail.paymentSchedule.vat" | translate }}
          </th>
          <th scope="col" id="DueDate">
            {{ "contractDetail.paymentSchedule.dueDate" | translate }}
          </th>
          <th scope="col" id="OutstandingAmount" *ngIf="contract.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING">
          @switch (contract?.dictionaryContractType.code) {
            @case (ContractType.CREDIT) {
                {{('outstandingAmount.credit' | translate)}}
            }
            @case (ContractType.FINANCIAL_LEASING) {
                {{('outstandingAmount.financialLeasing' | translate)}}
            }
          }
          </th>
          <th scope="col" id="InvoiceNumber">
            {{ "contractDetail.paymentSchedule.invoice" | translate }}
          </th>
          <th scope="col" id="IsPaid">
            {{ "contractDetail.paymentSchedule.state" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let paymentSchedule of paymentSchedules">
          <td HJSuppress
            [attr.data-label]="
              'contractDetail.paymentSchedule.number' | translate
            "
            id="Number"
            class="g-column-index"
          >
            {{ paymentSchedule?.number }}
          </td>
          <td HJSuppress
            [attr.data-label]="
              'contractDetail.paymentSchedule.type' | translate
            "
            id="Type"
            class="g-column-index"
          >
            {{ paymentSchedule?.type }}
          </td>
          <td HJSuppress
            [attr.data-label]="
              'contractDetail.paymentSchedule.value' | translate
            "
            id="Value"
            class="g-column-nr-highlighted"
          >
            <div class="d-flex align-items-center justify-content-center">
              {{ paymentSchedule?.value | number: "1.2" }} {{ paymentSchedule?.currency }}
              <i *ngIf="contract.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING"
                class="app-icon icon icon-warning-circle info-tooltip-trigger ms-1"
               [ngbTooltip]="valueTooltip"
               tooltipClass="custom-tooltip opacity-100"></i>
            </div>
          </td>
          <td HJSuppress
            *ngIf="contract.dictionaryContractType.code !== ContractType.CREDIT"
            [attr.data-label]="'contractDetail.paymentSchedule.vat' | translate"
            id="Vat"
            class="g-column-nr-highlighted"
          >
            {{ paymentSchedule?.vat | number: "1.2" }} {{ paymentSchedule?.currency }}
          </td>

          <td HJSuppress
            [attr.data-label]="'contractDetail.paymentSchedule.dueDate' | translate"
            id="DueDate"
            class="g-column-nr-highlighted"
          >
            {{ paymentSchedule?.dueDate | localizedDate }}
          </td>
          <td HJSuppress
            *ngIf="contract.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING"
            [attr.data-label]="
              'contractDetail.paymentSchedule.outstandingAmount' | translate
            "
            id="OutstandingAmount"
            class="g-column-nr"
          >
            {{ paymentSchedule?.outstandingAmount | number: "1.2" }} {{ paymentSchedule?.currency }}
          </td>
          <td HJSuppress
            [attr.data-label]="
              'contractDetail.paymentSchedule.invoice' | translate
            "
            id="InvoiceNumber"
          >
            <button *ngIf="paymentSchedule?.invoiceNumber"
              class="btn column-link-btn invoice-number"
              (click)="invoiceHandler(paymentSchedule?.invoiceId)"
            >
              {{ paymentSchedule?.invoiceNumber }} 
            </button>
            <span *ngIf="!paymentSchedule?.invoiceNumber" class="invoice-number">-</span>
          </td>
          <td
            [attr.data-label]="
              'contractDetail.paymentSchedule.state' | translate
            "
            id="IsPaid"
            class="state"
          >
            <span *ngIf="paymentSchedule?.isPaid" class="d-flex align-items-center justify-content-center">
              <i class="app-icon icon icon-check-circle-fill icon-xl paid-icon me-2"></i>
              {{ "contractDetail.paymentSchedule.statePaid" | translate }}
            </span>
            <span *ngIf="!paymentSchedule?.isPaid" class="d-flex align-items-center justify-content-center">
              <i class="app-icon icon icon-close-circle-fill icon-xl not-paid-icon me-2"></i>
              {{ "contractDetail.paymentSchedule.stateNotPaid" | translate }}
            </span>
          </td>

          <ng-template #valueTooltip>
            <div class="tooltip-row">
              <span class="tooltip-label">
                {{ "contractDetail.paymentSchedule.tooltip.principal" | translate }}
              </span>
              <span HJSuppress class="tooltip-value">
                {{ paymentSchedule?.tooltip?.principal | number: "1.2" }} {{ paymentSchedule?.currency }}
              </span>
            </div>
            <div class="tooltip-separator"></div>
            <div class="tooltip-row">
              <span class="tooltip-label">
                {{ "contractDetail.paymentSchedule.tooltip.interest" | translate }}
              </span>
              <span HJSuppress class="tooltip-value">
                {{ paymentSchedule?.tooltip?.interest | number: "1.2" }} {{ paymentSchedule?.currency }}
              </span>
            </div>
            <ng-container
              *ngFor="let extension of paymentSchedule?.tooltip?.extensions"
            >
              <div class="tooltip-separator"></div>
              <div class="tooltip-row">
                <span class="tooltip-label">
                  {{ extension?.value }}
                </span>
                <span HJSuppress class="tooltip-value">
                  {{ extension?.extensionValue | number: "1.2" }} {{ paymentSchedule?.currency }}
                </span>
              </div>
            </ng-container>
          </ng-template>
        </tr>
      </tbody>
    </table>
  </dynamic-table>
</div>
